import type { HackerOnboardingSocialProfiles } from '@/types';
import { SocialProfilesForm } from './components/SocialProfilesForm';

// 26-ar/onboarding/social-profiles/page.tsx. Unlike the same step inside the dispatcher,
// this one starts from whatever the hacker's newest profile already has.
export default function SocialProfiles({
  edition,
  defaultLinkedin,
  defaultX,
}: HackerOnboardingSocialProfiles) {
  return (
    <SocialProfilesForm
      edition={edition}
      defaultLinkedin={defaultLinkedin}
      defaultX={defaultX}
    />
  );
}
